import * as H     from "history"
import * as React from "react";

export interface FooterItem {
	content: any
}

export interface ButtonFooterItem extends FooterItem {
	disabled?: boolean
	title    : string
	onClick(event: React.SyntheticEvent<Element>): void
}

export interface LinkFooterItem extends FooterItem {
	disabled?: boolean
	title    : string
	to       : H.LocationDescriptor
}

export function isButtonFooterItem(footerItem: FooterItem): footerItem is ButtonFooterItem {
	return (<ButtonFooterItem>footerItem).onClick !== undefined
}

export function isLinkFooterItem(footerItem: FooterItem): footerItem is LinkFooterItem {
	return (<LinkFooterItem>footerItem).to !== undefined
}



// WEBPACK FOOTER //
// ./src/component/card/footer-item.ts